import type { ExplorerFinding } from '../../../../models/explorer/ExplorerFinding';
import type { FindingRule, FindingRuleContext } from '../types';
import { groupByTier } from '../../../../canvas/tierGrouping';

export const sgSprawlRule: FindingRule = {
  id: 'sg_sprawl',
  label: 'SG sprawl',
  description: 'Global: security-group count high relative to compute.',

  run(ctx: FindingRuleContext): readonly ExplorerFinding[] {
    let totalCompute = 0;
    let totalNetwork = 0;
    for (const b of ctx.bubbles) {
      const bands = groupByTier(b.interior ?? []);
      const count = (tier: string) =>
        bands.find((band) => band.tier === tier)?.dots.length ?? 0;
      totalCompute += count('compute');
      totalNetwork += count('network');
    }

    if (totalCompute >= 5 && totalNetwork / totalCompute >= 3) {
      const ratio = (totalNetwork / totalCompute).toFixed(1);
      return [
        {
          id: 'sg_sprawl:global',
          ruleId: 'sg_sprawl',
          severity: 'info',
          scope: 'global',
          title: 'SG sprawl',
          detail: `${totalNetwork} network resources vs ${totalCompute} compute — ratio ${ratio}:1 suggests cleanup opportunity.`,
          attrs: { ratio, totalCompute, totalNetwork },
        },
      ];
    }
    return [];
  },
};
